import { createContext, useContext } from "react"
import type { WeeklyCalculatorContextValue } from "./WeeklyCalculatorProvider"

export const WeeklyCalculatorContext = createContext<WeeklyCalculatorContextValue | undefined>(
  undefined,
)

export const useWeeklyCalculator = () => {
  const context = useContext(WeeklyCalculatorContext)

  if (!context) {
    throw new Error("useWeeklyCalculator must be used within a WeeklyCalculatorProvider")
  }

  return context
}
